import Skeleton from "react-loading-skeleton";

const TableSkeletonItem = () => <Skeleton count={1} height={20} borderRadius={16} />;

TableSkeletonItem.displayName = "DS.Table.Skeleton.Item";

export default TableSkeletonItem;
